export function apiErrorText(value, fallback = 'Non è stato possibile completare l’operazione. Riprova.') {
    if (typeof value === 'string') return value;
    if (value?.code === 'course_paywall') return 'Questa lezione richiede l’acquisto del corso completo.';
    if (value?.code === 'email_verification_required') return 'Verifica la tua email per continuare.';
    if (Array.isArray(value)) return value.map(item => apiErrorText(item, '')).filter(Boolean).join('\n') || fallback;
    if (value && typeof value === 'object') return apiErrorText(value.detail ?? value.message ?? value.msg, fallback);
    return fallback;
}
